module.exports = __webpack_public_path__ + "img/isng_search_demo.5f1ca33.gif";